<template>
  <b-modal id="modal-edit-user" size="md" no-close-on-backdrop>
    <!-- custom modal title -->
    <template #modal-title>
      <div class="d-flex align-items-center">
        <feather-icon size="20" icon="EditIcon" class="mr-05" />
        <span class="fs-18">Edit Informasi User</span>
      </div>
    </template>
    <!-- form container -->
    <loader-component v-if="is_loading" />
    <b-card no-body class="mb-0">
      <b-card-body>
        <validation-observer ref="biodataRules">
          <b-form>
            <!-- nama lengkap -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Nama Lengkap"
                rules="required"
              >
                <label for="nama-lengkap"
                  >Nama Lengkap <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserCheckIcon" />
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="data.nama"
                    id="nama-lengkap"
                    placeholder="Masukkan Nama Lengkap"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- username -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Username"
                rules="required"
              >
                <label for="username">
                  Username <span class="text-danger">*</span>
                </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="data.username"
                    id="username"
                    placeholder="Masukkan Username"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
                <small
                  v-if="username_available"
                  class="text-danger"
                  style="font-size: 10px"
                >
                  Username Telah Tersedia! Silahkan gunakan Username lain
                </small>
              </validation-provider>
            </b-form-group>
            <!-- email -->
            <b-form-group>
              <validation-provider #default="{ errors }" name="Email">
                <label for="email"> Email </label>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="data.email"
                    id="email"
                    placeholder="Masukkan Email"
                  />
                </b-input-group>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
            <!-- role -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Role"
                rules="required"
              >
                <label for="role">
                  Role <span class="text-danger">*</span>
                </label>
                <select v-model="data.role" id="role" class="form-control">
                  <option value="null" disabled selected>
                    Pilih Role User
                  </option>
                  <option value="0">Super Admin</option>
                  <option value="1">Admin</option>
                  <option value="2">User</option>
                </select>
                <small class="text-danger" style="font-size: 10px">{{
                  errors[0]
                }}</small>
              </validation-provider>
            </b-form-group>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
    <!-- custom modal footer -->
    <template #modal-footer>
      <!-- button batal -->
      <b-button
        variant="outline-danger"
        size="sm"
        class="float-right mr-05"
        @click="cancelEditUser"
      >
        Batal
      </b-button>
      <!-- button simpan -->
      <b-button
        variant="outline-info"
        size="sm"
        class="float-right"
        @click.prevent="editUser"
      >
        Simpan
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal,
  VBModal,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import floating_loader from "@/views/components/floatingLoader.vue";

export default {
  name: "editUser",
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    "loader-component": floating_loader,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      is_loading: false,
      username_available: false,
      //   validation
      required,
    };
  },
  methods: {
    editUser() {
      this.$refs.biodataRules.validate().then((success) => {
        if (success) {
          this.is_loading = true;
          this.username_available = false;
          let api = process.env.VUE_APP_API_URL + "users/edit/" + this.data._id;
          let params = {
            nama: this.data.nama,
            username: this.data.username,
            email: this.data.email ? this.data.email : "-",
            role: this.data.role,
          };
          useJwt.axiosIns
            .put(api, { data: params })
            .then(() => {
              this.user_data = {
                nama: null,
                username: null,
                email: null,
                password: null,
                role: null,
              };
              this.username_available = false;
              this.$bvModal.hide("modal-edit-user");
              this.$parent.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: `User berhasil diupdate`,
                },
              });
            })
            .catch(() => {
              this.username_available = true;
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    cancelEditUser() {
      (this.user_data = {
        name: null,
        username: null,
        email: null,
        role: null,
      }),
        this.$bvModal.hide("modal-edit-user");
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
<style>
.modal-title {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 20px !important;
  font-weight: bold;
}
</style>
